import React from "react";
import { connect } from "react-redux";
import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";
import "./BadgeNumberAlerts.scss";

export const DARK_RED = "#bb1e1d";

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class BadgeNumberAlerts extends React.Component<Props> {
    render() {
        if (this.props.num_unread_alerts <= 0) {
            return null;
        }

        const style: React.CSSProperties = {
            color: "white",
            backgroundColor: DARK_RED,
            marginLeft: "6px",
        };

        return (
            <span className="badge-number-alerts" style={style}>
                {this.props.num_unread_alerts}
            </span>
        );
    }
}

const mapState = (state: ReduxState) => ({
    num_unread_alerts: state.alerts.num_unread_alerts,
});

type ReduxProps = ReturnType<typeof mapState>;
export default connect<ReturnType<typeof mapState>, {}, OwnProps, ReduxState>(mapState)(BadgeNumberAlerts);
